export default __webpack_public_path__ + "static/g2_thumb-d85ade26e9a7a423254a55da8c263030.png";